import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLandingImages } from '../landing/LandingImageContext';

const { FiShoppingBag, FiMapPin, FiCheckCircle } = FiIcons;

const steps = [
  [
    '01',
    'Add To Cart',
    'Choose your saree, select the available options, and add it to your cart.'
  ],
  [
    '02',
    'Complete Checkout',
    'Enter your delivery details and choose your preferred payment method.'
  ],
  [
    '03',
    'Confirm Your Order',
    'Review your order, submit it securely, and receive your order number.'
  ]
];

function Ordering() {
  const images = useLandingImages();

  return (
    <section className="ordering">
      <div className="ordering-image">
        <img
          src={images.detail}
          alt="Close-up of luxurious golden silk saree details"
          loading="lazy"
        />
      </div>
      <div className="ordering-content">
        <span className="eyebrow">Simple &amp; Personal</span>
        <h2>Your ZEVI, Your Way</h2>
        <div className="steps">
          {steps.map(([number, title, text]) => (
            <article className="step" key={number}>
              <span>{number}</span>
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
        <p className="supporting-copy">
          Checkout securely using an available payment method configured by
          ZEVI.
        </p>
        <div className="payment-methods" aria-label="Ordering process">
          <span><SafeIcon icon={FiShoppingBag} /> Add to Cart</span>
          <span><SafeIcon icon={FiMapPin} /> Delivery Details</span>
          <span><SafeIcon icon={FiCheckCircle} /> Order Confirmation</span>
        </div>
        <a className="gold-button" href="#collection">
          Shop the collection
        </a>
      </div>
    </section>
  );
}

export default Ordering;